module.exports = __webpack_public_path__ + "img/18.967ab980.png";